/**
 * This action is used by resolvers originally created to handle navigation. Because React Router
 * handles navigation, not a middleware, the original actions have been replaced with this no-op action.
 */
export const NOOP_ACTION = {type: ''}
